// extracted by mini-css-extract-plugin
export default {"talkGroupTitle":"TalksPage_talkGroupTitle__bZH3C"};